const Slot = require('../domain/slot'),
	adManager = require('./adManager'),
	breakpoints = require('./breakpoints'),
	lazyLoadManager = require('./lazyLoadManager'),
	slotsStates = require('../domain/slotStates');

let slots = [];

function init(/** Settings */ settings) {
	slots = Object.keys(settings.slots).map((slotName) => {
		const slotDef = Object.assign({}, settings.slots[slotName], {
			'name': slotName
		});

		return new Slot(slotDef, settings);
	});

	window.advert.pubsub.subscribe('breakpoint.changed', _onBreakpointChange);

	adManager.onSlotVisibilityChanged(_onSlotVisibilityChanged);
	adManager.onImpressionViewable(_onImpressionViewable);

	if (typeof window.advert.querystring.get('taginfo') !== 'undefined') {
		window.advert.pubsub.subscribe('slot.rendered', _printSlotTagInfo);
		window.advert.pubsub.subscribe('slot.error', _printSlotTagInfo);
	}

	return Promise.all(slots.filter(_isUsedOnCurrentBreakpoint).map((slot) => slot.define()));
}

function _onBreakpointChange(currentBreakpoint) {
	return Promise.all(slots
		.filter((/** Slot*/ slot) => slot.renderBreakpoint && slot.renderBreakpoint !== currentBreakpoint)
		.filter((/** Slot*/ slot) => slot.state === slotsStates.RENDERED)
		.map((slot) => slot.refresh('breakpoint_changed')));
}

function _onSlotVisibilityChanged(e) {
	slots.forEach((/** Slot */ slot) => {
		if (slot.domId === e.slot.getSlotElementId()) {
			slot.updateInViewPercentage(e.inViewPercentage);
		}
	});
}

function _onImpressionViewable(e) {
	slots.forEach((/** Slot */ slot) => {
		if (slot.domId === e.slot.getSlotElementId()) {
			slot.updateHasImpression(true);
		}
	});
}

function _printSlotTagInfo(/** Slot */ slot) {
	const {
			name, sizeMapping, size, outOfPage, lazyLoaded, refreshable, state, isEmpty, creativeId, lineItemId, campaignId, advertiserId, refreshModes
		} = slot,
		curentSizes = slot.getSizeMapping()[breakpoints.getCurrentBreakpoint()],
		slotProps = {
			'version': window.advert.version,
			'slot': name,
			'adUnit': slot.getAdUnit(),
			sizeMapping,
			'sizes': curentSizes && curentSizes.map((sz) => Array.isArray(sz) ? sz.join('x') : sz).join(', '),
			'size': size && size.join('x'),
			outOfPage,
			lazyLoaded,
			refreshable,
			refreshModes,
			state,
			isEmpty,
			creativeId,
			lineItemId,
			campaignId,
			advertiserId
		},
		slotTargeting = adManager.getAppliedTargeting(slot);

	console.log('%c[ADVERT]%c Taginfo:', 'color:#fff;background:#cb1e7b;border-bottom: 1px solid #fff;', '');
	console.log('-- Slot properties --');
	console.log(Object.keys(slotProps).map((field) => `${field} = ${slotProps[field]}`).join('\n'));
	console.log('-- Targeting --');
	console.log(Object.keys(slotTargeting).map((field) => `${field} = ${slotTargeting[field]}`).join('\n'));
}

function _isUsedOnCurrentBreakpoint(slot) {
	const activeBreakpoint = breakpoints.getCurrentBreakpoint(),
		sm = slot.getSizeMapping();

	return slot.outOfPage || typeof sm[activeBreakpoint] !== 'undefined' && sm[activeBreakpoint].length > 0;
}

function getSlot(slotName) {
	return slots.find((/** Slot */ s) => s.name === slotName);
}

function loadSlot(slotName, nodeId) {
	return new Promise((resolve, reject) => {
		const slot = slots.find((/** Slot */ s) => s.name === slotName),
			slotIdentifier = nodeId || slotName;

		if (!slot) {
			return reject(new Error(`No slot found for ${slotName}`));
		}

		// Slot already loaded for this node
		if (slot.node && slot.node.getAttribute('data-advert-orig-id') === slotIdentifier) {
			return resolve();
		}

		const node = document.getElementById(slotIdentifier);

		if (!node) {
			return reject(new Error(`No DOM element found found for id ${slotIdentifier}`));
		}

		if (!_isUsedOnCurrentBreakpoint(slot)) {
			return resolve();
		}

		// Trying to load for a different DOM position
		if (slot.node && slot.node !== node) {
			return slot.reset()
				.then(() => slot.define())
				.then(() => slot.load(node))
				.then(() => {
					lazyLoadManager.addSlot(slot);
					resolve();
				});
		}

		return slot.load(node)
			.then(() => {
				lazyLoadManager.addSlot(slot);
				resolve();
			});
	});
}

function getSlots() {
	return slots;
}

module.exports = {
	init,
	loadSlot,
	getSlot,
	getSlots
};
